<template>
    <b-overlay 
        :show="nachrichten.length == 0" 
        class="pb-3"
        rounded="sm"
    >
        <div v-if="user != undefined"
            :class="darkmode ? 'bg-dark text-light border-secondary border mb-n3 p-3' : 'border mb-n3 p-3'"
            style="border-top-right-radius:0; border-top-left-radius:0"
        >
            <b-list-group 
                flush 
                :class="darkmode ? 'overflow-auto border rounded-top bg-light border-bottom-0 mt-n2 mx-n2 bg-dark border-secondary' : 'overflow-auto border rounded-top bg-light border-bottom-0 mt-n2 mx-n2'" 
                ref="chat" 
                style="max-height:24em; min-height:15em;border-bottom-right-radius:0; border-bottom-left-radius:0"
            >
                <b-list-group-item 
                    v-for="nachricht in nachrichten" 
                    :key="nachricht.id" 
                    :variant="user.id == nachricht.senderId ? 'info' : 'secondary'" 
                    :class="user.id != nachricht.senderId ? '' : 'text-right'"
                >
                    <small v-if="user.id == nachricht.senderId">Du {{getTimeStampString(nachricht.zeitpunkt)}}</small>
                    <small v-else-if="value.teilnehmer == null">User {{getTimeStampString(nachricht.zeitpunkt)}}</small>
                    <small v-else>{{value.teilnehmer.firstName}} {{getTimeStampString(nachricht.zeitpunkt)}}</small>
                    <p>{{nachricht.inhalt}}</p>
                </b-list-group-item>
            </b-list-group>
            <div class="mb-n2 mx-n2">
                <b-form-textarea :class="darkmode ? 'bg-dark text-light border-secondary rounded-0' : 'rounded-0'"
                    ref="txtarea" 
                    size="lg"
                    style="height:6em"
                    @keydown.enter.prevent="sendeNachrichtHandler" 
                    v-model="nachrichtenText" 
                    :disabled="value.teilnehmer == null" placeholder="Schreibe eine Nachricht..." />
                <b-button 
                    variant="info" 
                    style="border-top-right-radius:0; border-top-left-radius:0" 
                    :disabled="loading || value.teilnehmer == null || !$refs.txtarea || !$refs.txtarea.value" 
                    @click="sendeNachrichtHandler" block
                >
                    Nachricht senden
                    <b-spinner v-if="loading" small />
                </b-button>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BOverlay, BSpinner, BListGroupItem, BListGroup } from "bootstrap-vue"
import { setAlert} from '../tools'
import { sendeNachricht, updateNachrichten } from '../store/apiHelper'
export default {
    name: "AnfragenAnzeigeNachrichten",
    components:{
        BOverlay, 
        BSpinner,
        BListGroupItem, 
        BListGroup
    },
    props: {
        value: undefined
    },
    computed: mapGetters(['user', 'darkmode']),
    data() {
        return {
            nachrichten: [],
            nachrichtenText: '',
            nachrichtenInterval: null,
            loading: false,
        }
    },
    watch: {
        $route: async function () {
            this.nachrichten = []
            try {
                await this.handleUpdateNachrichten()
                this.leseNachrichten(this.value)
                this.scrollDown()
            }
            catch (err) {
                this.$bvToast.toast(err.response.data, {
                    title: 'Laden der Nachrichten fehlgeschlagen',
                    variant: 'danger',
                    toaster: 'b-toaster-top-full',
                    autoHideDelay: 5000,
                    appendToast: true
                })
            }
        }
    },
    methods: {
        ...mapActions(['leseNachrichten']),
        async handleUpdateNachrichten(msg = true)
        {
            try {
                var updated = await updateNachrichten(this.value)
                var longer = this.nachrichten.length != 0 && updated.length > this.nachrichten.length
                this.nachrichten = updated
                if(longer)
                {
                    this.scrollDown()
                    this.value.neueNachrichten = true
                    await this.leseNachrichten(this.value)
                }
            }
            catch (err) {
                if(msg)
                    setAlert(this, err.response.data, 'Laden der Nachrichten fehlgeschlagen', 'danger')
            }
        },
        async sendeNachrichtHandler()
        {
            if (this.nachrichtenText == "")
                return
            this.loading = true
            try {
                var newData = await sendeNachricht({ aid: this.value.id, inhalt: this.nachrichtenText })
                var i = this.nachrichten.findIndex(x => x.id == newData.id)
                if(i == -1)
                    this.nachrichten.push(newData)
                this.nachrichtenText = ''
                this.$refs['txtarea'].focus()
                setTimeout(this.$refs.txtarea.focus, 300)
                this.scrollDown()
            }
            catch (err) {
                setAlert(this, err.response.data, 'Senden fehlgeschlagen', 'danger')
            }
            this.loading = false
        },
        getTimeStampString(timeStamp) {
            var date = new Date(Date.parse(timeStamp))
            var now = new Date()
            if (date.getDate() == now.getDate() && date.getMonth() == now.getMonth() && date.getFullYear() ==now.getFullYear())
                return "um " + date.toLocaleTimeString()
            else
                return "am " + date.toLocaleDateString()
        },
        scrollDown(){
            setTimeout(() => {
                try{
                    this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight
                }
                catch(err){
                    return
                }
            }, 300)
        }
    },
    async mounted(){ 
        this.handleUpdateNachrichten()
        this.leseNachrichten(this.value)
        this.scrollDown()
        this.nachrichtenInterval = setInterval(() => this.handleUpdateNachrichten(false), 5000)
    },
    beforeDestroy() {
        clearInterval(this.nachrichtenInterval)
    },
}
</script>